<div class="threat-timeline" [ngClass]="{'dark-mode': isDarkTheme}">

  <!-- Header with title and minimize button -->
  <div class="threat-timeline-header">
    <div class="chart-heading">Threats Over Time</div>
    <i [class]="'bi ' + (isMinimized ? 'bi-arrows-angle-expand' : 'bi-dash-circle')" 
       class="minimize-icon" 
       (click)="toggleMinimize()"
       title="Minimize/Expand"></i>
  </div>

  <!-- Subtitle + Filters -->
  <div *ngIf="!isMinimized">
    <div class="chart-subtitle" *ngIf="timeline === 'last 24 hours'">Times shown in UTC (Coordinated Universal Time)</div>

    <div class="timeline-filters">

      <!-- Attack Type Dropdown -->
      <div class="filter-group" [class.open]="attackTypeDropdownOpen">
        <button class="chi-button -flat filter-trigger" (click)="toggleAttackTypeDropdown()">
          <span>Attack Type</span>
          <i class="chi-icon" [class.icon-chevron-down]="!attackTypeDropdownOpen" [class.icon-chevron-up]="attackTypeDropdownOpen" aria-hidden="true"></i>
        </button>
        <div class="filter-dropdown" *ngIf="attackTypeDropdownOpen">
          <div class="filter-dropdown-actions">
            <button class="chi-button -xs -flat" (click)="selectAllAttackTypes()">Select All</button>
            <button class="chi-button -xs -flat" (click)="deselectAllAttackTypes()">Clear</button>
          </div>
          <div class="filter-dropdown-body">
            <div class="chi-form__item" *ngFor="let t of availableAttackTypes">
              <label class="chi-checkbox">
                <input type="checkbox" class="chi-checkbox__input" [(ngModel)]="attackTypeSelections[t]" (ngModelChange)="renderSeries()">
                <span class="chi-checkbox__label">{{ t }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <!-- Industry Dropdown -->
      <div class="filter-group" [class.open]="industryDropdownOpen">
        <button class="chi-button -flat filter-trigger" (click)="toggleIndustryDropdown()">
          <span>Industry</span>
          <i class="chi-icon" [class.icon-chevron-down]="!industryDropdownOpen" [class.icon-chevron-up]="industryDropdownOpen" aria-hidden="true"></i>
        </button>
        <div class="filter-dropdown" *ngIf="industryDropdownOpen">
          <div class="filter-dropdown-actions">
            <button class="chi-button -xs -flat" (click)="selectAllIndustries()">Select All</button>
            <button class="chi-button -xs -flat" (click)="deselectAllIndustries()">Clear</button>
          </div>
          <div class="filter-dropdown-body">
            <div class="chi-form__item" *ngFor="let ind of availableIndustries">
              <label class="chi-checkbox">
                <input type="checkbox" class="chi-checkbox__input" [(ngModel)]="industrySelections[ind]" (ngModelChange)="renderSeries()">
                <span class="chi-checkbox__label">{{ ind }}</span>
              </label>
            </div>
          </div>
        </div>
      </div>

    </div><!-- timeline-filters -->
  </div>

  <!-- amcharts5 container - always in DOM so ViewChild resolves correctly -->
  <div #chartdiv class="timeline-chart-div" [style.display]="isMinimized ? 'none' : 'block'"></div>

</div><!-- threat-timeline -->
